const BASE = import.meta.env.VITE_API_BASE ?? "/api/v1";

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const initData = window.Telegram?.WebApp?.initData ?? "";
  const headers = new Headers(init.headers);
  if (initData) {
    headers.set("Authorization", `tma ${initData}`);
  }
  // FormData сам ставит правильный multipart boundary; кастомный application/json сломает upload.
  const isForm = typeof FormData !== "undefined" && init.body instanceof FormData;
  if (init.body && !headers.has("Content-Type") && !isForm) {
    headers.set("Content-Type", "application/json");
  }

  const resp = await fetch(`${BASE}${path}`, { ...init, headers });
  if (!resp.ok) {
    const text = await resp.text();
    // Бэк возвращает JSON {"detail": "..."} на ошибки — выдёргиваем человеческое сообщение.
    let detail = text;
    try {
      const parsed = JSON.parse(text);
      if (parsed && typeof parsed.detail === "string") detail = parsed.detail;
    } catch {
      /* not JSON — оставляем raw text */
    }
    const err = new Error(`${resp.status} ${detail}`) as Error & { status?: number };
    err.status = resp.status;
    throw err;
  }
  // 204 No Content (DELETE) — тела нет, json() упадёт. Возвращаем undefined как T.
  if (resp.status === 204) {
    return undefined as T;
  }
  return (await resp.json()) as T;
}
